import { render } from "./Loan_Topups.vue?vue&type=template&id=6a630fda"
import script from "./Loan_Topups.vue?vue&type=script&lang=js"
export * from "./Loan_Topups.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__